import * as ActionTypes from '../live';
export function clearLive() {
    return { type: ActionTypes.CLEAR_LIVE, section: 'live' };
}
export function clearLiveMatch() {
    return { type: ActionTypes.CLEAR_LIVE_MATCH, section: 'liveMatch' };
}



// WEBPACK FOOTER //
// ./src/actions/creators/live.js